const LeadershipScreen = () => {
  
    return (
       <p>Leadership Screen here</p>
    )
}

export default LeadershipScreen